import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISignature } from 'Modules/Communication/shared/models/Signature'

const emailSignatureSlice = createSlice({
  name: 'emailSignature',
  initialState: {
    data: null as ISignature | null,
    loading: false,
    error: null,
    processing: false,
    processingError: null,
  },
  reducers: {
    /**
     * Fetch
     */
    fetchRequest: (state) => {
      state.data = null
      state.loading = true
      state.error = null
    },
    fetchSuccess: (state, action: PayloadAction<ISignature>) => {
      state.data = action.payload
      state.loading = false
      state.error = null
    },
    fetchError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    /**
     * Edit
     */
    editRequested: (state, _: PayloadAction<string>) => {
      state.processing = true
      state.processingError = null
    },
    editSuccess: (state, action: PayloadAction<string>) => {
      state.processing = false
      state.processingError = null
      state.data = {
        ...state.data,
        additionalLines: action.payload,
      } as ISignature
    },
    editError: (state, action) => {
      state.processing = false
      state.processingError = action.payload
    },
  },
})

export default emailSignatureSlice
